import React, { useRef } from 'react';
import { Bar } from 'react-chartjs-2';
import { FiltroSopInventory, RepositorioSopInventory } from '../../core/repositories/sopInventoryRepositorio';
import { colorGraph, formatarDecimal, formatLargeNumber } from '../../core/utils/funcoes';
import { Chart, ChartData } from 'chart.js';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../core/contexts/toast';
import SopLoadingAnimation from '../../components/sopLoadingAnimation';
// import './RevenueStackedBarChart.scss';

const SopInventoryRevenueStackedBarChart: React.FC<{ filtro: FiltroSopInventory }> = (props) => {

  const { mostrarToast } = useToast();
  const { t } = useTranslation();
  const [data, setData] = React.useState<ChartData<"bar">>({} as ChartData<"bar">);
  const [carregando, setCarregando] = React.useState(true);

  React.useEffect(() => {
    setCarregando(true);
    new RepositorioSopInventory().getPlantInventoryClass(props.filtro).then((res) => {
      const labels: (number | null)[] = [];
      var datasets: any[] = [];

      res.forEach((item: any) => {
        if (labels.indexOf(item.des_industrial_plant) === -1)
          labels.push(item.des_industrial_plant);

      });
      var aux = {
        label: 'Finished Goods',
        data: res.map((x: any) => x.finished_goods),
        backgroundColor: colorGraph()[1],
      }
      datasets.push(aux);
      aux = {
        label: 'WIP',
        data: res.map((x: any) => x.work_in_progress),
        backgroundColor: colorGraph()[2],
      }
      datasets.push(aux);
      aux = {
        label: 'Raw Materials & Packaging',
        data: res.map((x: any) => x.raw_material),
        backgroundColor: colorGraph()[3],
      }
      datasets.push(aux);
      aux = {
        label: 'MRO',
        data: res.map((x: any) => x.others_mro),
        backgroundColor: colorGraph()[4],
      }
      datasets.push(aux);

      setData({
        labels: labels,
        datasets: datasets
      });
      setCarregando(false);
    }).catch((error) => {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    })
  }, [props.filtro]);


  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom' as const,
      },

    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          color: '#333',
        },
      },
      y: {
        ticks: {
          color: '#333',
          callback: (value: any) => formatLargeNumber(value, props.filtro?.value !== "Quantity" ? "$" : ""),
        },
        stacked: true,

        title: {
          display: true,
          text: props.filtro?.value !== "Quantity" ? 'Revenue (USD)' : 'Quantity',
          color: '#333',
          font: {
            weight: 'bold',
          },
        },
      },
    },
  };

  return (


    <div className="card p-3 shadow-sm border-0" style={{ height: '250px' }}>
      <strong className=" title-card">{props.filtro?.value !== "Quantity" ? 'Revenue' : 'Quantity'} by Plant and Inventory Class</strong>

      {carregando ?
        <SopLoadingAnimation type="BAR" />
        :
        <div>
          <Bar options={options} data={data} />
        </div>
      }
    </div>
  );
};

export default SopInventoryRevenueStackedBarChart;
